export enum SmartphoneCollectStatus{
    CANCELLED = "CANCELLED", 
    COMPLETED = "COMPLETED", 
    CONFIRMED = "CONFIRMED", 
    PENDING = "PENDING"
}

export class SmartphoneCollectRequestStatus{
    appointmentStatus: SmartphoneCollectStatus;
    
}

//create, update
export class SmartphoneCollectRequest {
    appointmentDate: string;
    isFastwebCustomer: boolean;
    notes: string;
    storeId: number;
    topicId: number;
    
}

export class SmartphoneCollectRequestSearch{
    appointmentDate: string;
    appointmentStatus: SmartphoneCollectStatus;
    pageNumber: number;
    pageSize: number;
    reservationDate: string;
    sortBy: string;
    storeAddress: string;
    storeCity: string;
    topicId: number;
    q: any;
    
}

export class SmartphoneCollectRequestExportCSV{
    appointmentDateFrom: any;
    appointmentDateTo: any;
    isTargetMailList: boolean;
    status: string;
    storeAddress: string;
    storeCity: string;
    q: string;
}